import { render, staticRenderFns } from "./ServiceAlert.vue?vue&type=template&id=425b7090&scoped=true"
import script from "./ServiceAlert.vue?vue&type=script&lang=js"
export * from "./ServiceAlert.vue?vue&type=script&lang=js"
import style0 from "./ServiceAlert.vue?vue&type=style&index=0&id=425b7090&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "425b7090",
  null
  
)

export default component.exports